import script from "./UiLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./UiLayout.vue?vue&type=script&setup=true&lang=js"

import "./UiLayout.vue?vue&type=style&index=0&id=72389eb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72389eb6"]])

export default __exports__